import React, { useMemo, useState } from "react"
import { Box, List, ListItemText } from "@material-ui/core"
import Clock from "react-live-clock"
import { useAuth } from "../../services"
import { SelectorMaster, NoItemsMessage, SearchInput } from ".."
import { RadioPickerListItem } from "../PickerListItems"
import { toId, truncateInMiddle, useDateUtils } from "../../utils"

const LocationSwitcher = ({ open, onClose }) => {
  const {
    settings: { locations },
    location,
    setLocation,
  } = useAuth()
  const isInline = false
  const { hasTimeOffsetFromUser } = useDateUtils()
  const [searchText, setSearchText] = useState("")

  const [newLocation, setNewLocation] = useState(location)

  const items = useMemo(
    () => locations.filter((item) => !searchText || item.name.toLowerCase().includes(searchText)),
    [locations, searchText]
  )

  const handleFilter = (text) => {
    setSearchText(text.toLowerCase())
  }

  const handleChange = (item) => {
    setNewLocation(item)
  }

  const handleSelect = () => {
    setLocation(newLocation)
    if (onClose) onClose()
  }

  const handleCancel = () => {
    if (onClose) onClose()
    setTimeout(() => setNewLocation(location), 100) // reset
  }

  const hasFilter = locations.length > 10
  const hasItems = Boolean(items.length)

  const form = (
    <>
      {hasFilter && (
        <SearchInput
          placeholder="Filter"
          initialValue={searchText}
          boxProps={{ pl: 0, pr: 0, mb: 2 }}
          onChange={handleFilter}
        />
      )}

      <Box mb={5}>
        {!hasItems && !hasFilter && (
          <NoItemsMessage>
            There are no locations linked to your user profile.
            <br />
            <br />
            Please contact your system administrator.
          </NoItemsMessage>
        )}
        {!hasItems && hasFilter && <NoItemsMessage>No matching locations</NoItemsMessage>}
        {hasItems && (
          <List disablePadding>
            {locations
              .filter((item) => !searchText || item.name.toLowerCase().includes(searchText))
              .map((loc) => {
                const checked = toId(loc) === toId(newLocation, true)
                return (
                  <RadioPickerListItem key={loc.id} checked={checked} onChange={() => handleChange(loc)}>
                    <ListItemText
                      primary={truncateInMiddle(loc.name, 50)}
                      secondary={
                        hasTimeOffsetFromUser(loc.timeZone) ? (
                          <Clock timezone={loc.timeZone} ticking format="h:mma z" />
                        ) : null
                      }
                      onClick={() => handleChange(loc)}
                      style={{ cursor: "pointer" }}
                    />
                  </RadioPickerListItem>
                )
              })}
          </List>
        )}
      </Box>
    </>
  )

  return (
    <SelectorMaster
      open={open}
      title="Change location"
      form={form}
      isInline={isInline}
      onSelect={handleSelect}
      onCancel={handleCancel}
    />
  )
}

export { LocationSwitcher }
